import React from 'react';
import ContentLoader from "react-content-loader";

const MockSearchResults = (props) => (
    <ContentLoader
        speed={2}
        width={400}
        height={600}
        backgroundColor="#f1f1f1"
        foregroundColor="#e1e1e1"
        {...props}
    >
        <rect x="0" y="0" rx="3" ry="3" width="180" height="180" />
        <rect x="200" y="0" rx="3" ry="3" width="180" height="180" />
        <rect x="0" y="200" rx="3" ry="3" width="180" height="180" />
        <rect x="200" y="200" rx="3" ry="3" width="180" height="180" />
        <rect x="0" y="400" rx="3" ry="3" width="180" height="180" />
        <rect x="200" y="400" rx="3" ry="3" width="180" height="180" />


    </ContentLoader>
)

export default MockSearchResults;
